import React from 'react'
import * as S from './style'

interface CheckboxProps {
  id?: string
  name: string
  label: string
  checked: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
}

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  name,
  label,
  checked,
  onChange,
  disabled,
}) => {
  const inputId = id || `${name}-${label}`

  return (
    <S.Container>
      <S.Input
        type="checkbox"
        id={inputId}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <S.Label htmlFor={inputId}>{label}</S.Label>
    </S.Container>
  )
}

export default Checkbox
